const page = require('../../../../../components/page/page')
const providerDt = require('./provider-dt')
const navmenu = require('../../../../../components/navmenu/navmenu')

import providerPage from "./provider-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false

//insert the page  on the body
function HTMLselect(detail) {

   HTMLwasSelected = true

   //load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", providerPage)

   providerDt.start({ "dest": "provider", "elem": "dt", "act": "select", "entity": "provider" })
   navmenu.start({
      act: 'renderNavMenu',
      container: '#providerdt-navmenu-container',
      items: [
         {
            label: 'Acc. Payable All',
            icon: 'payable',
            dest: 'provider',
            action: 'printReport',
            extraData: { entity: 'provider', elem: 'fullcont', reportName: 'account-payable-all' }
         },
         {
            label: 'Profit Report All',
            icon: 'profit',
            dest: 'provider',
            action: 'printReport',
            extraData: { entity: 'provider', elem: 'fullcont', reportName: 'account-all-profit' }
         },
         {
            label: 'All Contacts',
            icon: 'contact_page',
            dest: 'provider',
            action: 'printReport',
            extraData: { entity: 'provider', elem: 'fullcont', reportName: 'provider-contact-directory' }
         }
      ]
   })
}/*init*/

/****************ELEMENTS*****************/
export function start(detail) {

   if (!HTMLwasSelected) { HTMLselect(detail) }

   obj[detail.act].start(detail)
}

const obj = {

   show: { start: (detail) => { page.start(detail) } },


}/**/


